module.exports = {
    "longPressMessage": `Long press or press Alt + ArrowDown to open menu`
};


//# sourceMappingURL=en-US.main.js.map
